import React, { useEffect, useState } from 'react'
import { Card, Table, Button, Modal, Input, message, Tag, Space, Typography } from 'antd'
import { MessageOutlined } from '@ant-design/icons'
import { apiService } from '@services/apiService'

const { Text, Title } = Typography
const { TextArea } = Input

interface FeedbackItem {
  id: string
  userId: string
  userName: string
  content: string
  reply: string | null
  repliedAt: string | null
  createdAt: string
}

const FeedbackManagement: React.FC = () => {
  const [list, setList] = useState<FeedbackItem[]>([])
  const [loading, setLoading] = useState(false)
  const [replyModal, setReplyModal] = useState<{ open: boolean; item: FeedbackItem | null }>({ open: false, item: null })
  const [replyText, setReplyText] = useState('')

  const loadList = async () => {
    setLoading(true)
    try {
      const data = await apiService.get<FeedbackItem[]>('/system/feedback')
      setList(data || [])
    } catch { message.error('加载留言失败') }
    finally { setLoading(false) }
  }

  useEffect(() => { loadList() }, [])

  const handleReply = async () => {
    if (!replyModal.item) return
    if (!replyText.trim()) { message.warning('请输入回复内容'); return }
    try {
      await apiService.put(`/system/feedback/${replyModal.item.id}/reply`, { reply: replyText.trim() })
      message.success('回复成功')
      setReplyModal({ open: false, item: null })
      setReplyText('')
      loadList()
    } catch { message.error('回复失败') }
  }

  const columns = [
    {
      title: '用户ID', dataIndex: 'userId', width: 100,
      render: (v: string) => <Text style={{ fontSize: 12, fontFamily: 'monospace' }}>{v ? v.slice(0, 12) + '...' : '-'}</Text>,
    },
    { title: '用户昵称', dataIndex: 'userName', width: 120 },
    {
      title: '留言内容', dataIndex: 'content', ellipsis: true,
      render: (v: string) => <Text>{v}</Text>,
    },
    {
      title: '留言时间', dataIndex: 'createdAt', width: 160,
      render: (v: string) => v ? new Date(v).toLocaleString('zh-CN') : '-',
    },
    {
      title: '状态', width: 100,
      render: (_: any, r: FeedbackItem) => r.reply ? <Tag color="green">已回复</Tag> : <Tag color="orange">待回复</Tag>,
    },
    {
      title: '操作', width: 100,
      render: (_: any, r: FeedbackItem) => (
        <Button type="link" onClick={() => { setReplyModal({ open: true, item: r }); setReplyText(r.reply || '') }}>
          {r.reply ? '查看/编辑回复' : '回复'}
        </Button>
      ),
    },
  ]

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Title level={4} style={{ margin: 0 }}><MessageOutlined /> 用户留言反馈</Title>
        <Button onClick={loadList}>刷新</Button>
      </div>
      <Card>
        <Table rowKey="id" dataSource={list} columns={columns} loading={loading} pagination={{ pageSize: 20 }} />
      </Card>

      <Modal title="回复留言" open={replyModal.open} onOk={handleReply} onCancel={() => setReplyModal({ open: false, item: null })} okText="提交回复" cancelText="取消" width={600}>
        {replyModal.item && (
          <div>
            <div style={{ marginBottom: 16, padding: 12, background: '#f5f5f5', borderRadius: 6 }}>
              <Text strong>用户ID：{replyModal.item.userId} | {replyModal.item.userName}</Text>
              <div style={{ marginTop: 8 }}>
                <Text>{replyModal.item.content}</Text>
              </div>
            </div>
            <TextArea rows={4} value={replyText} onChange={e => setReplyText(e.target.value)} placeholder="输入回复内容..." />
          </div>
        )}
      </Modal>
    </div>
  )
}

export default FeedbackManagement
